import "./site_header.css";

$(function() {
  // На устройствах с мышью «Запросы» раскрываются по наведению, на тачскринах — по тапу
  if (window.matchMedia("(hover: hover)").matches) {
    $(".site_header_menu")
      .on("mouseenter", function() { $(this).attr("open", ""); })
      .on("mouseleave", function() { $(this).removeAttr("open"); })
      .on("click", "summary", function(e) { e.preventDefault(); });
  }

  $(document).on("click", function(e) {
    $(".site_header_menu[open]").not($(e.target).closest(".site_header_menu")).removeAttr("open");
  });

  $(document).on("keydown", function(e) {
    if (e.key === "Escape") $(".site_header_menu[open]").removeAttr("open");
  });
});
